import React from "react";
import Container from "react-bootstrap/Container";
import Footer from "../components/Footer";

function Contact() {
    return (
        <main className="my-5 mx-0">
            <Container className="container-fluid full-height-container">
                <div className="p-4 p-md-5 mb-4 rounded text-body-emphasis">
                    <div className="col-lg px-0 text-center">
                        <h1>Contact Us</h1>
                        <section>
                            <p>If you have any questions or concerns contact us at:</p>
                            <b>Rushta</b> <br/>
                            <b>Email:</b> mogock@gmail.com<br/>
                            <b>Phone:</b> 1-829-935-4441
                        </section>
                    </div>
                </div>
            </Container>
            <Footer/>
        </main>
    );
}

export default Contact;